import { useQueryHelper } from '@anytag/shared-hooks';
import { useInstagramHashtagPostDetailsQuery } from '@anytag/graphql';
import { PostModal, usePostModalContext } from '../shared';

export interface TemplateProps {
  className?: string;
}

export const Template = ({ className }: TemplateProps) => {
  const { t, enqueueSnackbar } = useQueryHelper();
  const { closeModal, selectedPostId } = usePostModalContext();
  const { data, loading } = useInstagramHashtagPostDetailsQuery({
    skip: !selectedPostId,
    variables: { postId: Number(selectedPostId) },
    onError: (error) => {
      closeModal?.();
      enqueueSnackbar(t(error.message), { variant: 'error' });
    }
  });

  const details = data?.instagramHashtagPostDetails;

  return (
    <PostModal.DetailsTemplate
      loading={loading}
      className={className}
      data={
        details
          ? {
              socialMedia: 'INSTAGRAM',
              postUrl: details?.postUrl,
              caption: details?.content,
              postDate: details?.postDate,
              images: details?.images || [],
              comments: details.commentList || [],
              info: { avatar: details?.avatarUrl, name: details?.instagramAccountName },
              statistics: { likes: details?.analysis?.likes, comments: details?.analysis?.comments }
            }
          : undefined
      }
    />
  );
};
